export const SCHOOL_KIND_ESF = "ESF";
export const SCHOOL_KIND_SKI_COOL = "SKI_COOL";
export const SCHOOL_KIND_SNOW_SYSTEMS = "SNOW_SYSTEMS";

const partnerSchoolKinds = [SCHOOL_KIND_SKI_COOL, SCHOOL_KIND_SNOW_SYSTEMS];

const partnerSchoolKindByHostname = {
  "ecards.snow-systems.fr": SCHOOL_KIND_SNOW_SYSTEMS,
};

const getSchoolKindFromHostname = () =>
  partnerSchoolKindByHostname[window.location.hostname] ?? SCHOOL_KIND_ESF;

export const getSchoolKind = (school) =>
  school
    ? partnerSchoolKinds.includes(school.partnerNetwork)
      ? school.partnerNetwork
      : SCHOOL_KIND_ESF
    : getSchoolKindFromHostname();
